"use strict";
import Auth from "../util/auth";
const TOGGLE_KEY = "reskinToggle";
const TOGGLE_KEY_USER = "reskinToggleUser";
const getSavedToggle = () => {
  return localStorage.getItem(TOGGLE_KEY);
};
const saveToggle = (val) => {
  localStorage.setItem(TOGGLE_KEY, val);
};
const getSavedToggleUser = () => {
  return localStorage.getItem(TOGGLE_KEY_USER);
};
const saveToggleUser = (val) => {
  localStorage.setItem(TOGGLE_KEY_USER, val ? "on" : "off");
};
const clearToggleUser = () => {
  localStorage.removeItem(TOGGLE_KEY_USER);
};
const getVals = () => {
  switch (getSavedToggle()) {
    case "on":
      return initAll(true);
    case "off":
      return initAll(false);
    default:
      if (getReskinUserToggle()) {
        return initAll(true);
      } else {
        return Auth.v3ReskinAccountSettings();
      }
  }
};
const getReskinUserToggle = () => {
  if (settingsAllEnabled(Auth.v3ReskinAccountSettings())) {
    return null;
  } else if (Auth.v3ReskinAccountSettings().everything) {
    return getSavedToggleUserBool();
  } else {
    return null;
  }
};
const initAll = (val) => {
  return {
    topLevel: val,
    settings: val,
    queues: val,
    indexAudit: val,
    everything: val
  };
};
const settingsAllEnabled = (val) => {
  return val.topLevel && val.settings && val.queues && val.indexAudit;
};
const getSavedToggleUserBool = () => {
  return getSavedToggleUser() != "off";
};
export default {
  getSavedToggle,
  getSavedToggleUserBool,
  saveToggle,
  getVals,
  saveToggleUser,
  getReskinUserToggle,
  clearToggleUser
};
